import {
  setLocalJSON, getLocalJSON, setSessionJSON, getSessionJSON,
} from "mazey";
import { enName } from "../config/page-settings";

export function wSetLocalStorage (key, value) {
  return setLocalJSON(`${enName}_${key}`, value);
}

export function wGetLocalStorage (key) {
  return getLocalJSON(`${enName}_${key}`);
}

export function wSetSessionStorage (key, value) {
  return setSessionJSON(`${enName}_${key}`, value);
}

export function wGetSessionStorage (key) {
  return getSessionJSON(`${enName}_${key}`);
}
